var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Exclude, Expose } from 'class-transformer';
import { IsBoolean, IsDateString, IsUUID } from 'class-validator';
import { SteuerberaterTokenStatus } from '../types/steuerberater-token-status.js';
/**
 * Read shape for the clinic-admin "Steuerberater-Link" UI. Surfaces issuance
 * and revocation timestamps, expiry and status — but NEVER the signed token
 * string itself. The token is only returned in the `MintSteuerberaterTokenResponseDto`
 * payload, immediately after minting. Re-displaying a previously-minted token
 * from a list view would defeat the single-use copy-link UX and is not
 * supported.
 */
export class SteuerberaterTokenResponseDto {
    id;
    officeLocationId;
    issuedByUserId;
    issuedAt;
    expiresAt;
    revokedAt;
    status;
    /**
     * Convenience flag for the UI: true iff `status === ACTIVE` and `expiresAt`
     * is still in the future. The public-route guard checks the same things
     * server-side; this is here purely so the clinic-admin UI does not have to
     * re-evaluate clock-skew across rows.
     */
    isUsable;
    createdAt;
    updatedAt;
}
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], SteuerberaterTokenResponseDto.prototype, "id", void 0);
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], SteuerberaterTokenResponseDto.prototype, "officeLocationId", void 0);
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], SteuerberaterTokenResponseDto.prototype, "issuedByUserId", void 0);
__decorate([
    IsDateString(),
    Expose(),
    __metadata("design:type", String)
], SteuerberaterTokenResponseDto.prototype, "issuedAt", void 0);
__decorate([
    IsDateString(),
    Expose(),
    __metadata("design:type", String)
], SteuerberaterTokenResponseDto.prototype, "expiresAt", void 0);
__decorate([
    IsDateString(),
    Expose(),
    __metadata("design:type", Object)
], SteuerberaterTokenResponseDto.prototype, "revokedAt", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], SteuerberaterTokenResponseDto.prototype, "status", void 0);
__decorate([
    IsBoolean(),
    Expose(),
    __metadata("design:type", Boolean)
], SteuerberaterTokenResponseDto.prototype, "isUsable", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], SteuerberaterTokenResponseDto.prototype, "createdAt", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], SteuerberaterTokenResponseDto.prototype, "updatedAt", void 0);
//# sourceMappingURL=steuerberater-token.response.dto.js.map